import React, { useState } from 'react';
import {
  Dropdown,
  DropdownButton,
  Form,
  FormControl,
  FormControlProps,
  FormGroup,
} from 'react-bootstrap';

type OptionType = {
  value: string | number;
  label: string;
};

type customSelectProps = FormControlProps & {
  label?: string;
  className?: string;
  options?: OptionType[];
  disabled?: boolean;
  placeholder?: string;
  minWidth?: string;
  defaultOption?: OptionType;
  onChange?: React.ChangeEventHandler;
  name?: string;
};

const CustomSelect = ({
  label,
  className,
  options,
  disabled,
  isValid,
  isInvalid,
  minWidth = '260px',
  placeholder = 'Select',
  onChange,
  defaultOption,
  name,
  ...props
}: customSelectProps) => {
  const [selectedOption, setSelectedOption] = useState(
    defaultOption?.label || ''
  );
  const [inputValue, setInputValue] = useState(defaultOption?.value || '');

  const handleSelect = (event: any) => {
    const optionSelected = options?.find((el) => el.value === event) || {
      label: placeholder,
      value: '',
    };
    onChange && onChange(event);
    setSelectedOption(optionSelected.label);
    setInputValue(optionSelected.value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  return (
    <FormGroup className={`${className ? className : ''} select-input-custom`}>
      {label && <Form.Label>{label}</Form.Label>}
      <FormControl
        type={'hidden'}
        name={name}
        isValid={isValid}
        isInvalid={isInvalid}
        onChange={handleChange}
        value={inputValue}
        {...props}
      />
      <DropdownButton
        title={selectedOption ? selectedOption : options?.find((option: any) => option.value === props.value)?.label || placeholder}
        disabled={disabled}
        bsPrefix={selectedOption ? 'form-control selected' : 'form-control'}
        onSelect={handleSelect}
        style={{ minWidth: `${minWidth}` }}
      >
        {options &&
          options.map((option, index) => (
            <Dropdown.Item
              eventKey={option.value}
              active={option.value === props.value ? true : false}
              key={index}
            >
              {option.label}
            </Dropdown.Item>
          ))}
      </DropdownButton>
    </FormGroup>
  );
};

export default CustomSelect;
